import { useCallback } from 'react';
import { setValue } from '../../../stream/transfer/control';
import useControlNext from '../useControlNext';
/**
 * Set formData value.
 *
 * @documented
 * @category State
 * @import import useSetFormValue from '@gef-ui/form-core/hooks/state/useSetFormValue'
 * @param {String} [formName] - when used, formStream$ is taken from stream storage instead of context
 * @returns {Function} setValueAction
 * @example
 *
 * 	const setFormValue = useSetFormValue();
 *
 *  setFormValue({fieldName: 'firstName', value: 'Jan'})
 *
 */ const useSetFormValue = (formName)=>{
    const next = useControlNext(formName);
    const setValueAction = useCallback((input)=>{
        next(setValue(input));
    }, [
        next
    ]);
    return setValueAction;
};
export default useSetFormValue;
